import { EditConnectionReactActionUtils } from '~src/connectivity/components/EditConnection/utils/EditConnectionActionUtils';
import { EditFilebasedConnectionDialogState } from '~src/connectivity/components/EditFilebasedConnection/EditFilebasedConnectionAction';
import { DataConnections } from '~src/datasource/dataConnection/resources/DataConnections';
import { IActionResult } from '~src/httpClient/serverApi/types/IActionResult';
import notifyResult = EditConnectionReactActionUtils.notifyResult;
import { EditableConnection } from '~src/connectivity/components/EditConnection/IEditConnectionDialog';

export async function updateUseRemoteQueryAgent(connections: EditableConnection[], dialogState: EditFilebasedConnectionDialogState): Promise<IActionResult> {
  let updateRequest: Promise<any>;
  updateRequest = DataConnections.updateConnectionUsingRemoteQueryAgent(connections.map(c => c.id), dialogState.usingRemoteQueryAgent);
  return updateRequest.then((result: IActionResult) => {
    notifyResult(result, connections);
    return result;
  });
}